import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { TARGETS } from '@pixi/constants';
import { AbstractMultiResource } from './AbstractMultiResource.mjs';
var ArrayResource = /*#__PURE__*/function (_AbstractMultiResourc) {
  _inherits(ArrayResource, _AbstractMultiResourc);
  var _super = _createSuper(ArrayResource);
  function ArrayResource(source, options) {
    var _this;
    _classCallCheck(this, ArrayResource);
    var _ref = options || {},
      width = _ref.width,
      height = _ref.height;
    var urls;
    var length;
    if (Array.isArray(source)) {
      urls = source;
      length = source.length;
    } else {
      length = source;
    }
    _this = _super.call(this, length, {
      width: width,
      height: height
    });
    if (urls) {
      _this.initFromArray(urls, options);
    }
    return _this;
  }
  _createClass(ArrayResource, [{
    key: "addBaseTextureAt",
    value: function addBaseTextureAt(baseTexture, index) {
      if (baseTexture.resource) {
        this.addResourceAt(baseTexture.resource, index);
      } else {
        throw new Error("ArrayResource does not support RenderTexture");
      }
      return this;
    }
  }, {
    key: "bind",
    value: function bind(baseTexture) {
      _get(_getPrototypeOf(ArrayResource.prototype), "bind", this).call(this, baseTexture);
      baseTexture.target = TARGETS.TEXTURE_2D_ARRAY;
    }
  }, {
    key: "upload",
    value: function upload(renderer, texture, glTexture) {
      var length = this.length,
        itemDirtyIds = this.itemDirtyIds,
        items = this.items;
      var gl = renderer.gl;
      if (glTexture.dirtyId < 0) {
        gl.texImage3D(gl.TEXTURE_2D_ARRAY, 0, glTexture.internalFormat, this._width, this._height, length, 0, texture.format, glTexture.type, null);
      }
      for (var i = 0; i < length; i++) {
        var item = items[i];
        if (itemDirtyIds[i] < item.dirtyId) {
          itemDirtyIds[i] = item.dirtyId;
          if (item.valid) {
            gl.texSubImage3D(gl.TEXTURE_2D_ARRAY, 0, 0, 0, i, item.resource.width, item.resource.height, 1, texture.format, glTexture.type, item.resource.source);
          }
        }
      }
      return true;
    }
  }]);
  return ArrayResource;
}(AbstractMultiResource);
export { ArrayResource };